import { Component, OnInit } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ProgressData } from 'src/app/modules/shared/dtos/progress-data';
import { ProgressIndicatingService } from 'src/app/modules/shared/services/progress-indicating.service';
import { PostContractRequestDTO } from '../dto/request-dto/post-contract-request-dto';
import { ConfigurationSelectionDTO } from '../dto/response-dto/configuration-selection-response-dto';
import { ContractDetailsResponseDTO } from '../dto/response-dto/contract-details-response-dto';
import { Contract } from '../interfaces/contract-details';
import { Countries } from '../interfaces/countries';
import { Manufacturers } from '../interfaces/manufacturers';
import { Selections } from '../interfaces/selection';
import { ServiceLevels } from '../interfaces/service-levels';
import { EditContractService } from '../services/edit-contract.service';

@Component({
    selector: 'app-edit-contract',
    templateUrl: './edit-contract.component.html',
    styleUrls: ['./edit-contract.component.scss']
})
export class EditContractComponent implements OnInit {
    public isDataAvailable : boolean = false
    public recieverManufacturerResponse : Manufacturers[] = [];
    public serviceLevelResponse : ServiceLevels[] = [];
    public countryResponse: Countries[] = [];
    public contractsList : Contract;
    public geoGatingMode = [{ name: 'Classical', value: 'Classical' }, { name: 'Ungeogated', value: 'Ungeogated' }];
    public filteredData: Countries
    private progress$ = new Subject<ProgressData>();
    // public disableButton : boolean = true;
    public tempContractList: Contract;
    public enableFields: boolean = false;
    public selectedServicelevelId : ServiceLevels;
    public noRecordsFound : boolean = false;

    public constructor(
        public fb: FormBuilder,
        public _editContractService: EditContractService,
        private progressService: ProgressIndicatingService,
        private messageService: MessageService
    ) {}

    public contractDetailsForm = new FormGroup({
        pac: new FormControl('', [
            Validators.required,
            Validators.pattern(/^[a-zA-Z0-9]+$/),
            Validators.minLength(12),
            Validators.maxLength(13)
        ]),
        contractId: new FormControl('', [
            Validators.required,
            Validators.pattern(/^[0-9]+$/)
        ]),
        receiverManufacturer: new FormControl('', [Validators.required])
    });

    public editContractForm = new FormGroup({
        partnerId: new FormControl({ value: '', disabled: true }, null),
        partnerName: new FormControl({ value: '', disabled: true }, null),
        productCode: new FormControl('', [Validators.required, Validators.pattern(/^\d{4}(\-\d{2}\-\d{1})?$/)]),
        serviceLevel: new FormControl('', [Validators.required]),
        coverageLevel: new FormControl({ value: '', disabled: true }, null),
        geogatingMode: new FormControl(''),
        longitude: new FormControl('', [
            Validators.pattern(/^-?\d{1,10}(\.\d{1,7})?$/),
            Validators.min(-180),
            Validators.max(180)
        ]),
        countryName: new FormControl('', [Validators.required]),
        startDate: new FormControl({ value: '', disabled: true }, null),
        endDate: new FormControl({ value: '', disabled: true }, null),
        countryCode: new FormControl('')
    });

    public ngOnInit(): void {
        this.isDataAvailable = false;
        this.noRecordsFound = false;
        // this.disableButton = true;
        this.enableFields = false;
        this.contractDetailsForm.patchValue({
            receiverManufacturer: null
        });
        this.getConfigurationSelectionContract();
    }

    public getConfigurationSelectionContract(): void {
        this.progressService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Loading Country Details',
                details: 'Please wait...',
                done: false
            }
        });
        this.countryResponse = [];
        this._editContractService.getConfigurationSelectionContract().pipe(
            filter((response: ConfigurationSelectionDTO): boolean => response.responseCode === 0),
            map((response: ConfigurationSelectionDTO): Selections => response.selections!)
        ).subscribe((selections: Selections) => {
            this.sendProgressDoneSignal();
            this.countryResponse = selections.countries!;
            this.recieverManufacturerResponse = selections.manufacturers;
            this.serviceLevelResponse = selections.serviceLevels;
        }, (error) => {
            this.messageService.add({ severity: 'error', summary: 'Fail', detail: error.error.responseMessage });
            this.sendProgressDoneSignal();
        });
    }

    public onChangeCountry(event : { value : {}}) : void {
        // this.disableButton = true;
        this.filteredData = {};
        this.filteredData = this.countryResponse.find(country => country.name === event.value)!;
        this.editContractForm.patchValue({
            longitude: +this.filteredData?.longitude!
        });
        // if (this.contractsList?.countryCode !== this.filteredData?.countryabbr) {
        //     this.disableButton = false;
        // } else {
        //     this.disableButton = true;
        // }
    }

    public onChangeServiceLevel(event : {value :{}}) : void {
        this.messageService.add({ severity: 'warn', detail: 'Update Product Code' });
        // this.selectedServicelevelId = this.serviceLevelResponse.find(name => name.name === event.value)!;
    }

    public onChangeGeogatingMode(event: { value : {}}): void {
        this.messageService.add({ severity: 'warn', detail: 'Update Product Code' });
    }

    public checkFieldValues() : boolean {
        const filteredCountry = this.countryResponse.find(country => country.countryabbr === this.contractsList?.countryCode)!;
        const previousDataCheck = {
            productCode: this.contractsList?.productCode,
            serviceLevel: this.contractsList?.serviceLevel ? this.contractsList?.serviceLevel : null,
            geogatingMode: this.contractsList?.geogatingMode ? this.contractsList?.geogatingMode?.charAt(0).toUpperCase() + this.contractsList?.geogatingMode!?.substring(1).toLowerCase() : null,
            longitude: this.contractsList?.longitude ? this.contractsList?.longitude : filteredCountry?.longitude,
            countryName: filteredCountry?.name,
            countryCode: this.contractsList?.countryCode
        };

        const currentDataCheck = {
            productCode: this.editContractForm.value.productCode,
            serviceLevel: this.editContractForm.value.serviceLevel ? this.editContractForm.value.serviceLevel : null,
            geogatingMode: this.editContractForm.value.geogatingMode ? this.editContractForm.value.geogatingMode : null,
            longitude: this.editContractForm.value.longitude,
            countryName: this.editContractForm.value.countryName,
            countryCode: this.editContractForm.value.countryCode
        };
        if (JSON.stringify(previousDataCheck) !== JSON.stringify(currentDataCheck)) {
            return false;
        } else {
            return true;
        }
    }

    // public onChangeInput(event: AbstractControl) : void {
    //     if (JSON.parse(JSON.stringify(event)) !== JSON.parse(JSON.stringify(this.tempContractList))) {
    //         this.disableButton = false;
    //     } else {
    //         this.disableButton = true;
    //     }
    // }

    public getContractDetails() : void {
        this.enableFields = false;
        // this.disableButton = true;
        this.noRecordsFound = false;
        this.progressService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Loading Contract Details',
                details: 'Please wait...',
                done: false
            }
        });
        this._editContractService.getContractDetails(this.contractDetailsForm.value.pac, this.contractDetailsForm.value.contractId,
            this.contractDetailsForm.value.receiverManufacturer.name).pipe(
            filter((response: ContractDetailsResponseDTO): boolean => response.responseCode === 0),
            map((response: ContractDetailsResponseDTO): Contract => response.contract!)
        ).subscribe((contract: Contract) => {
            if (contract !== undefined) {
                this.isDataAvailable = true;
                this.contractsList = contract!;
                this.sendProgressDoneSignal();
                if (this.contractsList?.isTopconPartner === true) {
                    this.enableFields = true;
                }
                const filteredCountry = this.countryResponse.find(country => country.countryabbr === this.contractsList?.countryCode)!;
                this.editContractForm.patchValue({
                    geogatingMode: this.contractsList?.geogatingMode?.charAt(0).toUpperCase() + this.contractsList?.geogatingMode!?.substring(1).toLowerCase(),
                    productCode: this.contractsList?.productCode,
                    partnerId: this.contractsList?.partnerId,
                    partnerName: this.contractsList?.organizationDisplayName,
                    coverageLevel: this.contractsList?.serviceCoverage,
                    countryName: filteredCountry?.name,
                    longitude: this.contractsList?.longitude ? this.contractsList?.longitude : filteredCountry?.longitude,
                    countryCode: filteredCountry?.countryabbr,
                    serviceLevel: this.contractsList?.serviceLevel
                });
                this.tempContractList = {
                    productCode: this.contractsList?.productCode,
                    serviceLevel: this.contractsList?.serviceLevel,
                    geogatingMode: this.contractsList?.geogatingMode?.charAt(0).toUpperCase() + this.contractsList?.geogatingMode!?.substring(1).toLowerCase(),
                    longitude: this.contractsList?.longitude ? this.contractsList?.longitude : filteredCountry?.longitude,
                    countryName: filteredCountry?.name,
                    countryCode: this.contractsList?.countryCode
                };
                if (this.contractsList?.serviceCoverage === 'Global') {
                    this.editContractForm.get('countryName')?.clearValidators();
                    this.editContractForm.get('countryName')?.updateValueAndValidity();
                    this.editContractForm.get('serviceLevel')?.clearValidators();
                    this.editContractForm.get('serviceLevel')?.updateValueAndValidity();
                } else {
                    this.editContractForm.get('countryName')?.setValidators([Validators.required]);
                    this.editContractForm.get('countryName')?.updateValueAndValidity();
                    this.editContractForm.get('serviceLevel')?.setValidators([Validators.required]);
                    this.editContractForm.get('serviceLevel')?.updateValueAndValidity();
                }
            } else {
                this.noRecordsFound = true;
                this.isDataAvailable = false;
                this.sendProgressDoneSignal();
            }
        }, (error) => {
            this.isDataAvailable = false;
            this.messageService.add({ severity: 'error', summary: 'Fail', detail: error.error.responseMessage });
            this.sendProgressDoneSignal();
        });
    }

    public saveContract() : void {
        this.progressService.show({
            progress$: this.progress$,
            initial: {
                done: false,
                header: 'Saving Contract Details',
                details: 'Please wait...'
            }
        });

        this.selectedServicelevelId = this.serviceLevelResponse.find(name => name.name === this.editContractForm.value.serviceLevel)!;
        const input : PostContractRequestDTO = {
            requestData: {
                geogatingMode: this.editContractForm.value.geogatingMode,
                productCode: this.editContractForm.value.productCode,
                longitude: +this.filteredData?.longitude! ? +this.filteredData?.longitude! : this.editContractForm.value.longitude,
                ...(this.filteredData?.latitude! && { latitude: this.filteredData?.latitude! }),
                countryCode: this.filteredData?.countryabbr ? this.filteredData?.countryabbr : this.contractsList?.countryCode,
                manufacturer: this.contractDetailsForm.value.receiverManufacturer.name,
                pac: this.contractDetailsForm.value.pac,
                contractId: this.contractDetailsForm.value.contractId,
                organizationDisplayName: this.contractsList?.organizationDisplayName,
                partnerId: this.contractsList?.partnerId,
                serviceCoverage: this.contractsList?.serviceCoverage,
                contractEndDate: this.contractsList?.contractEndDate,
                serviceLevelId: this.selectedServicelevelId ? this.selectedServicelevelId?.id : this.contractsList?.serviceLevelId,
                contractService: this.editContractForm.value.serviceLevel
            }
        };
        this._editContractService.updateContractDetails(input).subscribe(
            (response) => {
                this.apiResponsePopup(response.responseMessage!, response.responseCode!);
                this.sendProgressDoneSignal();
            },
            error => {
                this.apiResponsePopup(error.error.responseMessage!, error.responseCode!);
                this.sendProgressDoneSignal();
            }
        );
    }

    private sendProgressDoneSignal(): void {
        this.progress$.next({
            header: '',
            done: true
        });
    }

    private apiResponsePopup(responseMsg: string, responseCode: number) :void {
        if (responseCode === 0) {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: responseMsg });
            this.getContractDetails();
        } else {
            this.messageService.add({ severity: 'error', summary: 'Fail', detail: responseMsg });
        }
    }

    public onCancel() : void {
        const filteredCountry = this.countryResponse.find(country => country.countryabbr === this.contractsList?.countryCode)!;
        this.editContractForm.patchValue({
            geogatingMode: this.contractsList.geogatingMode,
            productCode: this.contractsList.productCode,
            longitude: this.contractsList?.longitude ? this.contractsList?.longitude : filteredCountry?.longitude,
            serviceLevel: this.contractsList?.serviceLevel ? this.contractsList?.serviceLevel : '',
            countryName: filteredCountry?.name
        });
        // this.checkFieldValues();
        this.editContractForm.clearValidators();
        this.editContractForm.updateValueAndValidity();
    }
}
